// Estilos do modal de aplicar template em massa (busca + árvore serviço -> circuito)
const styles = (theme) => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  // Coluna única (busca + árvore + rodapé) ocupando a altura do dialog
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    height: "calc(82vh - 190px)",
    overflow: "hidden",
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexShrink: 0,
  },
  buscaField: { flex: 1 },
  // Árvore rolável com altura controlada pelo dialogContent
  listaBox: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  grupoBox: {
    borderRadius: 2,
    border: `1px solid ${theme?.palette?.divider}`,
    backgroundColor: theme?.palette?.background?.default,
    p: 1,
  },
  grupoHeader: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  grupoTitulo: {
    flex: 1,
    fontSize: 13,
    fontWeight: 600,
    color: theme?.palette?.text?.primary,
  },
  circuitoRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    pl: 4,
  },
  circuitoLabel: {
    flex: 1,
    fontSize: 12,
    color: theme?.palette?.text?.primary,
  },
  // Mesmo visual do chip CONFIGURADO da lista de serviços (cardSelection.js)
  chipConfigurado: {
    display: "inline-flex",
    alignItems: "center",
    px: 1,
    py: 0.25,
    borderRadius: 1,
    fontSize: "0.65rem",
    fontWeight: "bold",
    bgcolor: "success.light",
    color: "success.contrastText",
  },
  badgeDiagrama: {
    display: "inline-flex",
    alignItems: "center",
    px: 1,
    py: 0.25,
    borderRadius: 1,
    fontSize: "0.65rem",
    fontWeight: "bold",
    bgcolor: theme?.palette?.info?.light,
    color: theme?.palette?.info?.contrastText,
  },
  novoCircuitoRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    pl: 4,
  },
  novoCircuitoField: {
    flex: 1,
    "& .MuiInputBase-input": {
      fontSize: 12,
      fontStyle: "italic",
      color: theme?.palette?.text?.secondary,
    },
  },
  emptyText: {
    fontSize: 13,
    color: theme?.palette?.text?.secondary,
    textAlign: "center",
    p: 2,
  },
  footerBox: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    p: 2,
    pt: 0,
  },
  aplicarHint: {
    fontSize: 11,
    color: theme?.palette?.text?.secondary,
    textAlign: "center",
  },
  // Mensagem de bloqueio por pendência (D7) — mesmo tamanho do hint normal, mais destacada
  aplicarHintBloqueado: {
    fontSize: 11,
    color: theme?.palette?.warning?.main,
    textAlign: "center",
    fontWeight: 600,
  },
});

export default styles;
